import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer'
  }
}))

export default useStyles
